<template>
    <div class="cc_ssc-block">
        <g-switch-list1
                class="cs_horizontal"
                v-for="(inner, ind) in horizontal"
                :key="'cc_' + ind"
                :horizontal-type="2"
                :title="inner.title"
                :chip="chip"
                :columns="5"
                :list="inner.list"></g-switch-list1>
    </div>
</template>

<script>
  import GSwitchList1 from '../../c_game-switch/switch-list/g_switch-1'; // 横向
  export default {
    name: "cc_ssc-1",
    components: {
      GSwitchList1
    },
    props: {
      chip: String,
      data: {
        type: Object,
        default() {
          return {
            vertical: [],
            horizontal: []
          }
        }
      }
    },
    computed: {
      horizontal() {
        return this.data.horizontal || [];
      }
    },
  }
</script>

<style scoped lang="stylus">
    .cc_ssc-block {
        .cs_horizontal {
            margin-top 7px
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/cc_ssc/cc_ssc-2.vue